import type { TokenPayload } from './extractTokenPayloadFromAuthorizationHeader';

/**
 * The token payload contains the iss and sub fields:
 * - "iss": "https://auth-staging.pflegenavi.at/auth/realms/default_tenant",
 * - "sub": "d84c3d16-9881-4d9b-86c3-ff560a28f862",
 * - "gm": [
 *     "/service_providers/ea2cc1e4-8406-4969-a184-4d51e72f6741"
 *   ],
 */

export const extractRealmAndUserIdFromTokenPayload = (
  tokenPayload: TokenPayload | undefined
): { realm: string; userId: string } | undefined => {
  let userInfo: { realm: string; userId: string } | undefined = undefined;

  if (tokenPayload) {
    const realmParts = tokenPayload?.iss?.split('/');
    if (!realmParts) {
      return userInfo;
    }

    // The last part contains the realm name
    const realm = realmParts[realmParts.length - 1];

    if (
      !tokenPayload?.sub ||
      typeof tokenPayload.sub !== 'string' ||
      typeof realm !== 'string'
    ) {
      return undefined;
    }

    userInfo = {
      userId: tokenPayload.sub,
      realm,
    };
  }

  return userInfo;
};

export const extractServiceProviderGroupMembershipFromTokenPayload = (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  tokenPayload: any
): string[] | undefined => {
  if (
    tokenPayload &&
    Array.isArray(tokenPayload?.gm) &&
    tokenPayload.gm.length > 0 &&
    typeof tokenPayload.gm[0] === 'string'
  ) {
    return tokenPayload.gm.map((entry: string) =>
      entry.replace('/service_providers/', '')
    );
  }

  return undefined;
};
